import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core';
import { IFrameComponent, iframeResizer } from 'iframe-resizer';
import { HaloLoaderService } from '../../core/halo-loader/halo-loader.service';

@Directive({
  selector: '[appIframeResizer]'
})
export class IframeResizerDirective implements AfterViewInit, OnDestroy {

  component: IFrameComponent | null;
  showloader : false;

  @Output()
  onIFrameMessage: EventEmitter<any> = new EventEmitter();

  constructor(public element: ElementRef,
    private loader: HaloLoaderService) { }

  ngAfterViewInit() {
    const components = iframeResizer({
      log:true,
							autoResize: true,
							inPageLinks: true,
							interval: 7500,
							heightCalculationMethod: 'lowestElement',
							minHeight: 600,
							checkOrigin: false,
              messageCallback : (messageData) => { // Callback fn when message is received
								var data = messageData.message;
                this.onIFrameMessage.emit(data);
              },
              resizedCallback: function () {
							//	console.log('iFrame Ready: ID in the parent page is: ' + iframeId);
              }
              // readyCallback: function () {
							// 	var iframeId = window.parentIFrame.getId();
							// //	console.log('iFrame Ready: ID in the parent page is: ' + iframeId);
							// }
    }, this.element.nativeElement);

    /* save component reference so we can close it later */
    this.component = components && components.length > 0 ? components[0] : null;
  }


  ngOnDestroy(): void {
    if (this.component && this.component.iFrameResizer) {
      this.component.iFrameResizer.close();
    }
  }

}
